import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'aa-footer',
    templateUrl: './footer.component.html',
    styleUrls: [
        './footer.component.scss'
    ],
    standalone: false
})
export class FooterComponent implements OnInit
{
    @Input() percentLeftPart: number = 100 / 3;
    @Input() percentMiddlePart: number;
    percentRightPart: number = 100 / 3;

    constructor() { }

    ngOnInit ()
    {
        this.percentRightPart = this.percentLeftPart;
    }
}
